import { isFreeTierShipperSubscription } from "utils";

import { useRoleContext } from "./useRoleContext";
import { useSubscriptionStatus } from "./useSubscriptionStatus";
import { useSwrFetch } from "./useSwrFetch";

interface ShipperQuotesOnlyPostingsLeftResponse {
  remaining_quotes_only_postings: number;
  limit: number;
}

interface UseShipperQuotesOnlyPostingsLeftProps {
  // Lets the caller hold the fetch off until the allowance is actually
  // relevant (e.g. a public quotes only posting is being drafted), instead of
  // paying for it on every mount.
  enabled: boolean;
}

export function useShipperQuotesOnlyPostingsLeft(
  props: UseShipperQuotesOnlyPostingsLeftProps,
) {
  const { enabled } = props;
  const { role } = useRoleContext();
  const { subscription } = useSubscriptionStatus();

  // Free tier shippers cannot post quotes only shipments at all, so there is
  // no allowance to fetch for them.
  const url =
    enabled &&
    role?.type === "SHIPPER" &&
    role.company?.id &&
    subscription != null &&
    !isFreeTierShipperSubscription(subscription)
      ? `/subscription/company/${role.company.id}/quotes-only-postings-left`
      : null;

  const { data, loading, error, refetch } =
    useSwrFetch<ShipperQuotesOnlyPostingsLeftResponse>({
      url,
      errorMessage: "Failed to fetch quotes only postings left",
    });

  return {
    remainingQuotesOnlyPostings: data?.remaining_quotes_only_postings ?? null,
    loading,
    error,
    refetch,
  };
}
